import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export default function ProLockPill({ label = "Pro feature" }: { label?: string }) {
  return (
    <Link
      to="/pricing"
      className="inline-flex items-center gap-1 rounded-full border border-primary/40 bg-primary/10 px-2.5 py-1 text-[11px] font-medium text-primary hover:bg-primary/15"
    >
      <Lock className="h-3 w-3" />
      {label} — upgrade
    </Link>
  );
}